module.exports = __webpack_public_path__ + "img/belt-driven-tragedy.1615efc4.jpg";